import { useState } from "react"

export const useHealthKeyValueFormHandling = () => {
    const [keyValueData, setKeyValueData] = useState({
    // key value information
    category: "",
    keyName: "",
    sortOrder: "",
    parentKeyId: "",
    active: true,

    // key value information status
    categoryStatus: "unchecked",
    keyNameStatus: "unchecked",
    sortOrderStatus: "unchecked",
    parentKeyIdStatus: "unchecked"
    });
    

    const handleKeyValueDataChange = (event,selectEvent) => {
        let formState ={...keyValueData};

        if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){                

                case "category": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "parentKeyId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }
        else if(event && event.target){
            switch(event.target.name){
                case "keyName": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "sortOrder": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setKeyValueData(formState);
    
    }

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
            keyValueData.categoryStatus === "success" &&
            keyValueData.keyNameStatus === "success" &&
            keyValueData.sortOrderStatus === "success"
        ) {
            allowSubmit = true;
        } else {
            allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        keyValueData,
        setKeyValueData,
        handleKeyValueDataChange,
        checkAllFields
    }
}